export default __webpack_public_path__ + "static/SCORPION_scaled-a5cfffa4657266ed259ae4477506796e.gif";